module.exports = __webpack_public_path__ + "static/media/CHAP01-CASQUE-BLANC.d0257b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP01-CASQUE-BLANC.png
// module id = 276
// module chunks = 0